'use strict'

angular.module('rmStationSettings')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('stationsettings', {
                url: '/stationsettings',
                views: {
                    stationSettingsOverview: {
                        templateUrl: '/partial/app.partials.stationsettings.overview',
                        controller: 'StationSettingsOverviewCtrl',
                        controllerAs: 'stationSettingsCtrl'
                    }
                },
                onEnter: ['bladesManager', function (bladesManager) {

                    bladesManager.clearAll()
                    bladesManager.insert({ viewName: 'stationSettingsOverview', size: 'full' })
                }]
            })

            /*
             Settings
             */
            .state('stationsettings.settings', {
                url: '/settings',
            })

            .state('stationsettings.settings.general', {
                url: '/general',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.settings.general',
                        controller: 'StationSettingsGeneralCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.settings.epgStartTimes', {
                url: '/epg-start-times',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.settings.epgStartTimes',
                        controller: 'StationSettingsEpgStartTimesCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.settings.themes', {
                url: '/themes',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.settings.themes',
                        controller: 'StationSettingsThemesCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })

            /*
             Station Information
             */
            .state('stationsettings.stationInformation', {
                url: '/station-information'
            })
            .state('stationsettings.stationInformation.basicInformation', {
                url: '/basic-information',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.station-information.basicInformation',
                        controller: 'StationSettingsBasicInformationCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.stationInformation.contactInformation', {
                url: '/contact-information',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.station-information.contactInformation',
                        controller: 'StationSettingsContactInformationCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.stationInformation.advancedInformation', {
                url: '/advanced-information',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.station-information.advancedInformation',
                        controller: 'StationSettingsAdvancedInformationCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.stationInformation.logoUrls', {
                url: '/logo-urls',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.station-information.logoUrls',
                        controller: 'StationSettingsLogoUrlsCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.stationInformation.bearers', {
                url: '/bearers',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.bearers.bearers',
                        controller: 'StationSettingsBearersOverviewCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.stationInformation.bearers.field', {
                url: '/field-:fieldId',
                views: {
                    'field@stationsettings.stationInformation.bearers': {
                        templateUrl: '/partial/app.partials.stationsettings.bearers.field',
                        controller: 'StationSettingsBearersFieldCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })

            /*
             Datamodel
             */
            .state('stationsettings.datamodel', {
                url: '/datamodel/:modelName',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.datamodel.model',
                        controller: 'StationSettingsModelCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.datamodel.type', {
                url: '/type-:typeId',
                views: {
                    'type@stationsettings.datamodel': {
                        templateUrl: '/partial/app.partials.stationsettings.datamodel.type',
                        controller: 'StationSettingsTypeCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.datamodel.type.field', {
                url: '/field-:fieldId',
                views: {
                    'field@stationsettings.datamodel': {
                        templateUrl: '/partial/app.partials.stationsettings.datamodel.field',
                        controller: 'StationSettingsFieldCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })

            /*
             API Settings
             */
            .state('stationsettings.api', {
                url: '/api'
            })
            .state('stationsettings.api.rest', {
                url: '/rest',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.api.rest_overview',
                        controller: 'StationSettingsApiRestOveviewCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.api.rest.token', {
                url: '/token-:tokenId',
                views: {
                    'token@stationsettings.api.rest': {
                        templateUrl: '/partial/app.partials.stationsettings.api.rest_token',
                        controller: 'StationSettingsApiRestTokenCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.api.push', {
                url: '/push',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.api.push',
                        controller: 'StationSettingsApiPushCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })


            /*
             Multistation Settings
             */
            .state('stationsettings.multi', {
                url: '/multi'
            })
            .state('stationsettings.multi.master', {
                url: '/master',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.multi.master',
                        controller: 'StationSettingsMasterCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.multi.slave', {
                url: '/slave',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.multi.slave',
                        controller: 'StationSettingsSlaveCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })

            /*
             Radiovis Settings
             */
            .state('stationsettings.visuals_strings', {
                url: '/visuals_strings'
            })
            .state('stationsettings.visuals_strings.visuals', {
                url: '/visuals',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.visuals_strings.visuals',
                        controller: 'StationSettingsVisualsCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.visuals_strings.visuals.slide', {
                url: '/slideId-:slideId'
            })
            .state('stationsettings.visuals_strings.strings', {
                url: '/strings',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.visuals_strings.strings',
                        controller: 'StationSettingsStringsCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.visuals_strings.strings.string', {
                url: '/stringId-:stringId'
            })

            /*
         Print Templates
         */
            .state('stationsettings.print_templates', {
                url: '/visuals_templates'
            })
            .state('stationsettings.print_templates.print_rundown', {
                url: '/print_rundown',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.print_templates.print_rundown',
                        controller: 'StationSettingsPrintRundownCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.print_templates.print_rundown.rundownTemplate', {
                url: '/rundownTemplateId-:rundownTemplateId'
            })
            .state('stationsettings.print_templates.print_epg', {
                url: '/print_epg',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.print_templates.print_epg',
                        controller: 'StationSettingsPrintEpgCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.print_templates.print_epg.epgTemplate', {
                url: '/epgTemplateId-:epgTemplateId'
            })

            /*
             Export Settings
             */
            .state('stationsettings.export', {
                url: '/export'
            })
            .state('stationsettings.export.radiodns', {
                url: '/radiodns',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.export.radiodns',
                        controller: 'StationSettingsRadioDNSCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.export.vtuner', {
                url: '/vtuner',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.export.vtuner',
                        controller: 'StationSettingsVTunerCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.export.tunein', {
                url: '/tunein',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.export.tunein',
                        controller: 'StationSettingsTuneInCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.export.darfm', {
                url: '/darfm',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.export.darfm',
                        controller: 'StationSettingsDarFMOverviewCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.export.darfm.item', {
                url: '/itemId-:itemId',
                views: {
                    'item@stationsettings.export.darfm': {
                        templateUrl: '/partial/app.partials.stationsettings.export.darfm_item',
                        controller: 'StationSettingsDarFMItemCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.export.metadata_radio', {
                url: '/metadata-radio',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.export.metadata_radio',
                        controller: 'StationSettingsMetadataradioCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            /*
             Modules
             */
            .state('stationsettings.applications', {
                url: '/applications',
            })
            .state('stationsettings.applications.manage', {
                url: '/manage',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.applications.overview',
                        controller: 'StationSettingsApplicationsOverviewCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.applications.manage.edit', {
                url: '/:applicationId',
                views: {
                    'detail@stationsettings.applications.manage': {
                        templateUrl: '/partial/app.partials.stationsettings.applications.detail',
                        controller: 'StationSettingsApplicationsDetailCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
            .state('stationsettings.applications.manage.edit.widget', {
                url: '/widget/:widgetIndex',
            })
            .state('stationsettings.applications.marketplace', {
                url: '/marketplace',
                views: {
                    'stationSettingsContent@stationsettings': {
                        templateUrl: '/partial/app.partials.stationsettings.applications.marketplace',
                        controller: 'StationSettingsApplicationsMarketplaceCtrl',
                        controllerAs: 'ctrl'
                    }
                }
            })
        ;
    }]);
